import '@/app/app.css';
import './blog.css';

import '@/app/app';
import '@/layouts/main/main';
import { ViewSwitcher } from '@/shared/common/view-switcher/view-switcher';

window.addEventListener('DOMContentLoaded', () => {
	new ViewSwitcher(document.querySelector('.js-view-switcher'), document.querySelector('.js-view-switcher-feed'));
});
